<template>
	<div class="mainPage">
		<div class="flex just-between" style="margin-bottom: 15px;">
			<div>
				<el-button
					type="primary"
					plain
					icon="el-icon-circle-plus"
					:size="inputSize"
					@click="handleAdd()"
					>增 加</el-button
				>
			</div>
		</div>

		<el-table :data="pageList.content">
			<el-table-column
				type="index"
				label="序号"
				width="60"
				:index="indexMethod"
			></el-table-column>
			<el-table-column
				prop="ip"
				label="IP地址"
			></el-table-column>
			<el-table-column
				prop="type"
				label="配置类型"
			>
				<template slot-scope="scop">
					<span v-if="scop.row.type === 2">网段</span>
					<span v-else>IP</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="createTime"
				label="创建时间"
			></el-table-column>
			<el-table-column label="操作" width="200">
				<template slot-scope="scope">
					<el-button
						type="text"
						icon="el-icon-delete"
						:size="inputSize"
						@click="handleDelete(scope.row)"
						>删除</el-button
					>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="queryForm.pageNum"
			:page-size="queryForm.pageSize"
			:page-sizes="[10, 20, 50, 100]"
			layout="total, sizes, prev, pager, next, jumper"
			:total="pageList.totalElements"
		>
		</el-pagination>

		<white-list-manage-dialog
			:visible="whiteListManageDialog.visible"
			:ip="whiteListManageDialog.ip"
			@close="whiteListManageDialogClosed"
		></white-list-manage-dialog>
	</div>
</template>

<script>
import WhiteListManageDialog from "./WhiteListManageDialog.vue";

export default {
	components: {
		WhiteListManageDialog
	},
	data() {
		return {
			inputSize: "small",
			queryForm: {
				pageNum: 1,
				pageSize: 10,
			},
			pageList: {
				content: [],
				totalElements: 0,
			},
			whiteListManageDialog: {
				visible: false,
				ip: "",
			}
		};
	},
	methods: {
		indexMethod(index) {
			index =
				index +
				1 +
				(this.queryForm.pageNum - 1) * this.queryForm.pageSize;
			return index;
		},
		getPageList() {
			this.$api.system.getWhiteListPageList(this.queryForm).then((res) => {
				if (res.code === 200) {
					res.data.content.forEach((item) => {
						item.createTime = item.createTime
							? item.createTime.split("T")[0]
							: "";
						item.modifyTime = item.modifyTime
							? item.modifyTime.split("T")[0]
							: "";
					});
					this.pageList = res.data;
				}
			});
		},
		handleSizeChange(pageSize) {
			this.queryForm.pageSize = pageSize;
			this.getPageList();
		},
		handleCurrentChange(pageNum) {
			this.queryForm.pageNum = pageNum;
			this.getPageList();
		},
		handleAdd() {
			this.whiteListManageDialog.ip = "";
			this.whiteListManageDialog.visible = true;
		},
		handleDelete(data) {
			this.$confirm("确定要删除" + (data.type === 2 ? "网段" : "IP") + "【" + data.ip + "】吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				this.$api.system.removeWhiteListInfo(data.ip).then((res) => {
					if (res.code === 200) {
						this.$message.success("删除成功");
						this.getPageList();
					} else {
						this.$message.error(res.message);
					}
				});
			});
		},
		whiteListManageDialogClosed(success) {
			this.whiteListManageDialog.visible = false;
			if (success) {
				this.getPageList();
			}
		},
	},
	mounted() {
		this.getPageList();
	},
};
</script>
